import { getApiUrl } from '@/js/utils/getApiUrl';

/** Включите true, для MOK. */
const USE_DOCUMENT_SEARCH_MOCK = false;

interface DocData {
  documentName: string;
  documentTitle: string;
  fileUrl: string;
  fileFormat: string;
  fileSize: string;
}

const MOCK_DOCUMENTS: DocData[] = [
  {
    documentName: 'Федеральный закон от 29.07.2017 № 216-ФЗ',
    documentTitle:
      'Об инновационных научно-технологических центрах и о внесении изменений в отдельные законодательные акты РФ',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'PDF',
    fileSize: '0.87 MB',
  },
  {
    documentName: 'Устав АО «Управляющая компания ИНТЦ МГУ «Воробьевы горы»',
    documentTitle: 'Устав акционерного общества',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'DOC',
    fileSize: '0.87 MB',
  },
  {
    documentName: 'Федеральный закон от 29.07.2017 № 216-ФЗ',
    documentTitle:
      'Об инновационных научно-технологических центрах и о внесении изменений в отдельные законодательные акты РФ',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'DOC',
    fileSize: '0.87 MB',
  },
  {
    documentName: 'Устав АО «Управляющая компания ИНТЦ МГУ «Воробьевы горы»',
    documentTitle: 'Устав акционерного общества',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'PDF',
    fileSize: '0.87 MB',
  },
  {
    documentName: 'Федеральный закон от 29.07.2017 № 216-ФЗ',
    documentTitle:
      'Об инновационных научно-технологических центрах и о внесении изменений в отдельные законодательные акты РФ',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'PDF',
    fileSize: '0.87 MB',
  },
  {
    documentName: 'Устав АО «Управляющая компания ИНТЦ МГУ «Воробьевы горы»',
    documentTitle: 'Устав акционерного общества',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'PDF',
    fileSize: '0.87 MB',
  },
  {
    documentName: 'Федеральный закон от 29.07.2017 № 216-ФЗ',
    documentTitle:
      'Об инновационных научно-технологических центрах и о внесении изменений в отдельные законодательные акты РФ',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'PDF',
    fileSize: '0.87 MB',
  },
  {
    documentName: 'Устав АО «Управляющая компания ИНТЦ МГУ «Воробьевы горы»',
    documentTitle: 'Устав акционерного общества',
    fileUrl: '/assets/mock-data/Брендбук ИНТЦ.pdf',
    fileFormat: 'PDF',
    fileSize: '0.87 MB',
  },
];

function filterMockDocuments(query: string): DocData[] {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return MOCK_DOCUMENTS.filter(
    (d) =>
      d.documentName.toLowerCase().includes(q) || d.documentTitle.toLowerCase().includes(q),
  );
}

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function highlightMatch(text: string, query: string): string {
  const safeText = escapeHtml(text);
  const normalizedQuery = query.trim();

  if (!normalizedQuery) {
    return safeText;
  }

  const pattern = new RegExp(escapeRegExp(normalizedQuery), 'gi');

  return safeText.replace(
    pattern,
    '<span class="search-block__match-highlight">$&</span>',
  );
}

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ?  '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

function getDocFormatIconPath(fileFormat: string): string {
  const key = fileFormat.trim().replace(/^\./, '').toUpperCase();

  switch (key) {
    case 'PDF':
      return `${ICONS_BASE}/doc/doc_pdf.svg`;
    case 'DOC':
      return `${ICONS_BASE}/doc/doc_doc.svg`;
    case 'DOCX':
      return `${ICONS_BASE}/doc/doc_docx.svg`;
    case 'XLS':
      return `${ICONS_BASE}/doc/doc_xls.svg`;
    case 'XLSX':
      return `${ICONS_BASE}/doc/doc_xlsx.svg`;
    case 'PPT':
      return `${ICONS_BASE}/doc/doc_ppt.svg`;
    case 'PPTX':
      return `${ICONS_BASE}/doc/doc_pptx.svg`;
    case 'TXT':
      return `${ICONS_BASE}/doc/doc_txt.svg`;
    case 'PNG':
      return `${ICONS_BASE}/doc/doc_png.svg`;
    case 'JPG':
    case 'JPEG':
      return `${ICONS_BASE}/doc/doc_jpg.svg`;
    case 'RAR':
      return `${ICONS_BASE}/doc/doc_rar.svg`;
    case 'ZIP':
      return `${ICONS_BASE}/doc/doc_zip.svg`;
    case 'MP4':
      return `${ICONS_BASE}/doc/doc_mp4.svg`;
    case 'AVI':
      return `${ICONS_BASE}/doc/doc_avi.svg`;
    case 'MPEG':
    case 'MPG':
      return `${ICONS_BASE}/doc/doc_mpeg.svg`;
    default:
      return `${ICONS_BASE}/doc/doc_none.svg`;
  }
}

function documentCardMarkup(item: DocData, query: string): string {
  const name = highlightMatch(item.documentName, query);
  const fmt = escapeHtml(item.fileFormat);
  const size = escapeHtml(item.fileSize);
  const href = escapeHtml(item.fileUrl);
  const downloadName = escapeHtml(item.fileUrl.split('/').pop() ?? 'document.pdf');
  const docIcon = getDocFormatIconPath(item.fileFormat);

  return `
     <article class="document-card document-card--search">
      <div class="document-card__icon">
        <img src="${docIcon}" alt="Иконка документа" />
      </div>
      <div class="document-card__content">
        <div class="document-card__document-name">
          <a class="document-card__document-link" href="${href}" target="_blank" rel="noopener noreferrer">${name}</a>
          <div class="document-card__document-file-format">
            ${fmt} / ${size}
          </div>
        </div>
      </div>
      <span class="document-card__document-download">
        <a class="document-card__document-download-link" href="${href}" download="${downloadName}">
          <img src="${ICONS_BASE}/download-icon.svg" alt="Скачать" />
        </a>
      </span>
    </article>
   `;
}

function formatMatchCountSummaryHtml(count: number, query: string): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  let word: string;
  if (mod10 === 1 && mod100 !== 11) {
    word = 'совпадение';
  } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    word = 'совпадения';
  } else {
    word = 'совпадений';
  }
  const q = escapeHtml(query);
  return `${count} ${word} для <span class="search-block__query">«${q}»</span>`;
}

export class DocumentsSearchWidget {
  private searchInput: HTMLElement | null;
  private searchResultList: HTMLElement | null;
  private accordionSearchResult: HTMLElement | null;
  private searchSummaryEl: HTMLElement | null;
  private noMatchesHintEl: HTMLElement | null;
  private mainAccordionsWrap: HTMLElement | null;
  private searchType?: string;
  private minChars: number;
  private debounceDelay: number;
  private debounceTimeout: number | undefined;
  private debouncedHandler: (query: string) => void;

  constructor(
    searchInput: string = 'aboutDocumentsSearch',
    searchResultList: string = 'inner-aboutDocsSearchResult',
    accordionSearchResult: string = 'accordionSearchResult',
    searchSummary: string = 'aboutDocsSearchResultSummary',
    noMatchesHintId: string = 'aboutDocsSearchResult-no-matches',
    mainAccordionsGroupId: string = 'aboutDocumentsAccordionGroup',
    minChars: number = 3,
    debounceDelay: number = 400,
    searchType?: string,
  ) {
    this.searchInput = document.getElementById(searchInput);
    this.searchResultList = document.getElementById(searchResultList);
    this.accordionSearchResult = document.getElementById(accordionSearchResult);
    this.searchSummaryEl = document.getElementById(searchSummary);
    this.noMatchesHintEl = document.getElementById(noMatchesHintId);
    this.mainAccordionsWrap = document.getElementById(mainAccordionsGroupId);
    this.searchType = searchType;
    this.minChars = minChars;
    this.debounceDelay = debounceDelay;

    this.debouncedHandler = this.debounce((q: string) => {
      this.performSearch(q);
    }, this.debounceDelay);
  }

  public init(): void {
    if (!this.searchInput) return;

    this.searchInput.addEventListener('input', (e: Event) => {
      const value = (e.target as HTMLInputElement).value.trim();
      this.debouncedHandler(value);
    });

    const clearBtn = this.searchInput
      .closest('[data-search-input]')
      ?.querySelector<HTMLButtonElement>('[data-search-clear]');

    clearBtn?.addEventListener('click', () => {
      clearTimeout(this.debounceTimeout);
      this.performSearch('');
    });
  }

  private debounce(fn: (query: string) => void, delay: number) {
    return (query: string) => {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = window.setTimeout(() => fn(query), delay);
    };
  }

  private async performSearch(query: string): Promise<void> {
    if (!this.searchResultList || !this.accordionSearchResult) return;

    if (query.length < this.minChars) {
      this.searchResultList.innerHTML = '';
      this.clearSearchSummary();
      this.setNoMatchesHintVisible(false);
      this.accordionSearchResult.classList.add('hidden');
      this.setMainAccordionsHidden(false);
      return;
    }

    this.accordionSearchResult.classList.remove('hidden');
    this.setMainAccordionsHidden(true);
    this.showLoading();

    try {
      let data: DocData[];

      if (USE_DOCUMENT_SEARCH_MOCK) {
        await new Promise((r) => setTimeout(r, 400));
        data = filterMockDocuments(query);
      } else {
        const params = new URLSearchParams({ q: query });
        if (this.searchType) {
          params.set('type', this.searchType);
        }

        const response = await fetch(`${getApiUrl('/api/searchResults.php')}?${params.toString()}`);

        if (!response.ok) {
          throw new Error(`Bad response: ${response.status}`);
        }

        data = (await response.json()) as DocData[];
      }

      this.renderResults(data, query);
    } catch {
      this.showError();
    }
  }

  private setSearchSummaryHtml(html: string): void {
    if (this.searchSummaryEl) {
      this.searchSummaryEl.innerHTML = html;
    }
  }

  private clearSearchSummary(): void {
    if (this.searchSummaryEl) {
      this.searchSummaryEl.textContent = '';
    }
  }

  private setNoMatchesHintVisible(visible: boolean): void {
    if (this.noMatchesHintEl) {
      this.noMatchesHintEl.classList.toggle('hidden', !visible);
      this.noMatchesHintEl.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }
  }

  private setMainAccordionsHidden(hidden: boolean): void {
    if (this.mainAccordionsWrap) {
      this.mainAccordionsWrap.classList.toggle('hidden', hidden);
    }
  }

  private showLoading(): void {
    if (!this.searchResultList) return;

    this.setNoMatchesHintVisible(false);
    this.searchResultList.innerHTML = `
      <div class="docs-search__loading">
        Поиск…
      </div>
    `;
  }

  private renderResults(data: DocData[], query: string): void {
    if (!this.searchResultList) return;

    const count = data?.length ?? 0;
    this.setSearchSummaryHtml(formatMatchCountSummaryHtml(count, query));

    if (!data || data.length === 0) {
      this.searchResultList.innerHTML = '';
      this.setNoMatchesHintVisible(true);
      return;
    }

    this.setNoMatchesHintVisible(false);
    this.searchResultList.innerHTML = data.map((item) => documentCardMarkup(item, query)).join('');
  }

  private showError(): void {
    this.clearSearchSummary();
    this.setNoMatchesHintVisible(false);
    this.setMainAccordionsHidden(false);
    if (!this.searchResultList) return;

    this.searchResultList.innerHTML = `
      <div class="docs-search__error">
        Ошибка при выполнении запроса.
      </div>
    `;
  }
}
